import '../../components/data-quality/data-quality.scss';

import { constants, helpPanelConstants } from '../Localization';

const DataQualityImpactBadgesHelp = () => {
    return (
        <div>
            <p>{helpPanelConstants.SEVERITY_TERMS}:</p>
            <ul>
                <li>
                    <span className="impactBadge high-impact">{constants.HIGH}</span>  
                    <span>{helpPanelConstants.IMPACT_BADGE_HIGH}</span>
                </li>
                <li>
                    <span className="impactBadge medium-impact">{constants.MEDIUM_UPPERCASE}</span> 
                    <span>{helpPanelConstants.IMPACT_BADGE_MEDIUM}</span>
                </li>
                <li>
                    <span className="impactBadge low-impact">{constants.LOW}</span> 
                    <span>{helpPanelConstants.IMPACT_BADGE_LOW}</span>
                </li>
            </ul>
        </div>
    );
};

export default DataQualityImpactBadgesHelp;
